export const dictionaryMixin = {
  inject: ['dictionaryService'],
  methods: {
    getPhrase(phraseKey) {
      return this.dictionaryService.phrases ? this.dictionaryService.phrases[phraseKey] : undefined
    }
  }
}
